import React, { useEffect, useState } from "react"
import { useSubscriptions } from "@/pages/subscriptions/useSubscriptions"
import { msalInstance } from "@/index"
import { hasValidIdToken } from "@/utils/accessToken"

type SubscriptionHandlerProps = {
    fetchPlans: boolean
}

const SubscriptionHandler = ({ fetchPlans }: SubscriptionHandlerProps) => {
    const account = msalInstance.getActiveAccount()
    const enabled = Boolean(account && hasValidIdToken(account))

    useSubscriptions(fetchPlans, enabled)

    return null
}

export const LoginSuccessListener: React.FC = () => {
    const [loginSuccess, setLoginSuccess] = useState(false)
    const [delayedExecution, setDelayedExecution] = useState(false)
    useEffect(() => {
        const handleLoginSuccess = () => {
            setLoginSuccess(true)
        }

        window.addEventListener("login-success", handleLoginSuccess)

        return () => {
            window.removeEventListener("login-success", handleLoginSuccess)
        }
    }, [])

    // Effect to trigger delayed execution of useSubscriptions after login.
    useEffect(() => {
        if (loginSuccess) {
            const timer = setTimeout(() => {
                setDelayedExecution(true)
            }, 2000)

            return () => clearTimeout(timer)
        }
    }, [loginSuccess])

    const currentPath = window.location.href.split("#")[1] || "/"
    if (currentPath === "/terms-of-service" || currentPath === "/privacy-policy") {
        return null
    }

    return (
        <>
            {/* Render SubscriptionHandler immediately if not logged in. */}
            {!loginSuccess && <SubscriptionHandler fetchPlans={false} />}
            {/* Render SubscriptionHandler after a delay when logged in. */}
            {delayedExecution && <SubscriptionHandler fetchPlans={true} />}
        </>
    )
}
